<template>
  <hsp-layout>
    <template v-slot:sidebar>
      <side-bar
        :background-color="sidebarBackground"
        short-title="HSP"
        title="HSP">
        <template slot="links">
          <sidebar-item
            v-if="!isUser"
            :link="{
              name: 'Summary',
              icon: 'tim-icons icon-single-copy-04',
              path: {
                name: 'InstanceSummary',
                params: {
                  surveyId: $route.params.surveyId,
                  urlId: $route.params.urlId,
                  routeFrom: $route.params.routeFrom
                }
              }
            }">
          </sidebar-item>
          <sidebar-item
            v-if="isInternalAdmin"
            :link="{
              name: 'Access',
              icon: 'tim-icons icon-badge',
              path: {
                name: 'InstanceAccess',
                params: {
                  surveyId: $route.params.surveyId,
                  urlId: $route.params.urlId,
                  routeFrom: $route.params.routeFrom
                }
              }
            }">
          </sidebar-item>
          <sidebar-item
            v-if="isInternalAdmin"
            :link="{
              name: 'Data',
              icon: 'tim-icons icon-chart-bar-32',
              path: {
                name: 'InstanceReports',
                params: {
                  surveyId: $route.params.surveyId,
                  urlId: $route.params.urlId,
                  routeFrom: $route.params.routeFrom
                }
              }
            }">
          </sidebar-item>
          <sidebar-item
            :link="{
              name: 'Dashboard',
              icon: 'tim-icons icon-chart-pie-36',
              path: {
                name: 'InstanceDashboard',
                params: {
                  surveyId: $route.params.surveyId,
                  urlId: $route.params.urlId,
                  routeFrom: $route.params.routeFrom
                }
              }
            }">
          </sidebar-item>
          <sidebar-item
            :link="{
              name: 'Reports',
              icon: 'tim-icons icon-cloud-download-93',
              path: {
                name: 'InstanceReportFiles',
                params: {
                  surveyId: $route.params.surveyId,
                  urlId: $route.params.urlId,
                  routeFrom: $route.params.routeFrom
                }
              }
            }">
          </sidebar-item>
        </template>
      </side-bar>
    </template>
  </hsp-layout>
</template>
<script>
  import HspLayout from './HspLayout';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        sidebarBackground: 'primary' //vue|blue|orange|green|red|primary,
      };
    },
    components: {
      HspLayout
    },
    computed: {
      ...mapGetters({
        isUser: 'adminUserIsUser',
        isInternalAdmin: 'adminUserIsInternalAdmin',
      }),
    },
  }
</script>
